import React from "react";
import ArisCoach from "../../Coach";
import "../styles.css";

const CoachPrivateV2 = () => {
  // Walkthrough is implemented inside ArisCoach now.
  return (
    <div className="coachv2-wrap">
      <ArisCoach />
    </div>
  );
};

export default CoachPrivateV2;
